const validName = (name) => {
    let validNamePattern = /^[a-zA-ZÅÄÖØåäöøéÉèÈêÊëËîÎïÏôÔöÖüÜûÛñÑçÇßÿŸŒœæÆ\s'\-–’`]*$/
    return validNamePattern.test(name)
}
export {
    validName
}
